import React, { useMemo } from 'react';
import ParentCardNoCol from '../../common/ParentCardNoCol';
import { drapcodeIcon } from '../../../common/custom/icon-library';
import { convertTimeStampToDate } from '../../../common/utils/dateUtils';
import showAlert from '../../../common/utils/alert';
import { Link } from 'react-router-dom';
import TooltipInfo from '../../../common/docs/TooltipInfo';
import { description } from '../../../common/utils/event_constants';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';

export const CustomFunctionTable = ({ projectId, version, actions, flag, customFunctions }) => {
  console.log('This is the version in the custom function that is being passed: ', version);
  console.log(
    'This is the typeof version in the custom function that is being passed: ',
    typeof version,
  );
  const handleDelete = (uuid) => {
    const preConfirm = async () => {
      try {
        await actions.deleteCustomFunction({ projectId, uuid, version });
        await Swal.fire('Deleted!', 'Function has been deleted.', 'success');
      } catch (error) {
        console.error('Error deleting function:', error);
        await Swal.fire('Error', 'Failed to delete function.', 'error');
      }
    };

    showAlert("You won't be able to revert it!", preConfirm, 'Yes, delete it!');
  };
  const handleClone = (customFunction) => {
    console.log('actions in my clone function', actions);
    const preConfirm = async () => {
      version = Number(version);
      const args = { projectId, customFunction, version };
      try {
        await actions.cloneCustomFunction(args);
        toast.success('cloned Successfully!');
      } catch (error) {
        console.error('Error deleting function:', error);
        toast.error('failed to cloned please try again');
      }
    };
    showAlert(
      `Do you want to clone ${customFunction.name} CustomFunction ?`,
      preConfirm,
      'Yes, clone it!',
    );
  };
  const componentRows = useMemo(() => {
    if (!Array.isArray(customFunctions)) return null;

    if (customFunctions.length) {
      return customFunctions.map((customFunction) => (
        <tr key={customFunction.uuid} className="text-left td-align-middle">
          <td>{customFunction.name}</td>
          <td>{convertTimeStampToDate(customFunction.createdAt)}</td>
          <td className="text-right">
            &nbsp;
            <Link
              className="btn btn-xs btn-primary"
              title={`Edit ${customFunction.name}`}
              to={{
                pathname: `/2.0/custom-component/${version}/v/${projectId}/customFunction/edit/${customFunction.uuid}`,
              }}
            >
              <i className="wb webconnect-pencil"></i>
            </Link>
            <Link
              className="btn btn-xs btn-theme-green"
              title={`Logs ${customFunction.name}`}
              to={{
                pathname: `/2.0/custom-component/${version}/v/${projectId}/customFunction/logs/${customFunction.uuid}`,
              }}
            >
              <i className="wb webconnect-file-text"></i>
            </Link>
            <button
              className="btn btn-xs btn-theme-submit"
              onClick={() => handleClone(customFunction)}
              title={`Clone ${customFunction.name}`}
            >
              <i className="wb webconnect-clone"></i>
            </button>
            <button
              className={`btn btn-xs btn-theme-delete`}
              onClick={() => (flag ? handleDelete(customFunction.uuid) : undefined)}
              title={`Delete ${customFunction.name}`}
              style={{ cursor: flag ? 'pointer' : 'not-allowed' }}
            >
              <i className="wb webconnect-trash-solid"></i>
              {!flag && (
                <>
                  &nbsp;
                  <TooltipInfo
                    title={description}
                    headerText={`Permission Disabled!`}
                    showHeader={true}
                    showArrow={true}
                  />
                </>
              )}
            </button>
          </td>
        </tr>
      ));
    } else {
      return (
        <tr>
          <td colSpan="3" className="align-middle text-center">
            No Custom Function!
          </td>
        </tr>
      );
    }
  }, [customFunctions, flag, projectId, version, actions]);

  return (
    <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
      <ParentCardNoCol
        title="Custom Function"
        icon="customFunction"
        bgColor="drapcode-violet"
        CtaComponent={
          <Link
            className="btn btn-theme-submit btn-md"
            title={'Create Custom Component'}
            to={{
              pathname: `/2.0/custom-component/${version}/v/${projectId}/customFunction/create`,
            }}
          >
            <i className={`wb ${drapcodeIcon('add')}`}></i> &nbsp;Create Custom Function
          </Link>
        }
      >
        <div className="table-responsive">
          <table className="table table-bordered table-hover table-sm table-word-break connector-list">
            <thead>
              <tr>
                <th>Name</th>
                <th>Created At</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>{componentRows}</tbody>
          </table>
        </div>
      </ParentCardNoCol>
    </div>
  );
};
